import React from 'react';
import {Menu, MenuProps} from "antd";
import {useHistory, useLocation} from 'react-router-dom';
import KeycloakService from "../../service/keycloak";
import jwtDecode from "jwt-decode";

interface Props {
}

function MainNavigation(props: Props) {

    const history = useHistory();
    const {pathname} = useLocation();
    const keycloak = KeycloakService.getInstance();
    const decodedToken: any  = keycloak.token ? jwtDecode(keycloak.token) : undefined;

    const menuItems = [{
        key: 'customers',
        label: 'Customers'

    }, {
        key: 'discounts',
        label: 'Discounts'

    }, {
        key: 'products',
        label: 'Products'
    }, {
        key: 'discount-codes',
        label: 'Discount Codes'
    }, {
        key: 'user',
        label: decodedToken.name || "User",
        style: {
            marginLeft: 'auto'
        },
        children: [{
            key: 'logout',
            label: 'Logout'
        }]
    }]

    const selectedKeys = menuItems.filter((item) => {
        return pathname.startsWith('/' + item.key)
    }).map((item) => item.key);

    const onClick: MenuProps['onClick'] = (e) => {
        if (e.key === 'logout') {
            window.sessionStorage.removeItem('token');
            keycloak.logout();
        } else {
            history.push('/' + e.key)
        }
    };

    return <Menu onClick={onClick} theme={'dark'} selectedKeys={selectedKeys} mode="horizontal" items={menuItems}/>;
}

export default MainNavigation;
